import { render, staticRenderFns } from "./ModalAsignarCarritoComponent.vue?vue&type=template&id=3fa742f6&"
import script from "./ModalAsignarCarritoComponent.vue?vue&type=script&lang=js&"
export * from "./ModalAsignarCarritoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports